import { Box, Grid } from '@mui/material';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import UltimaActualizacionComponent from '../equipos/UltimaActualizacionComponent';
import ShareArticleAdminComponent from '../page-components/noticias/share-article-admin';
import AnaliticaSocialNetworks from '../shared/analitica-social-networks';
import { mapJugadorPlantilla } from '@/features/plantillas-fantasy/GestionarPlantilla/hooks/useJugadoresPlantilla';

import NoticiaFlashAyudaModal from './noticia-flash-ayuda-modal';
import NoticiaFlashAuthor from './NoticiaFlashAuthor';
import NoticiaFlashJugadorInfo from './NoticiaFlashJugadorInfo';
import NoticiaFlashPlayerCard from './NoticiaFlashPlayerCard';

const NoticiasFlashSingleComponent = ({ noticia, h1 }) => {
    const router = useRouter();

    // Mapear jugadorPlantilla para desminificar
    const jugadorPlantillaMapeado = useMemo(() => {
        if (!noticia?.jugadorPlantilla) return null;
        return mapJugadorPlantilla(noticia.jugadorPlantilla);
    }, [noticia?.jugadorPlantilla]);

    const getTwitterAuthor = (author) => {
        if (author?.toLowerCase()?.includes('quijote')) {
            return '@DonQuijoteDeLaC';
        }
        return '@AnaliticaLaLiga';
    };

    return (
        <Box className="noticia-flash-single-component">
            <Grid container spacing={2}>
                {/* Columna principal - 9/12 en desktop */}
                <Grid size={{ xs: 12, md: 9 }}>
                    {/* Author */}
                    <NoticiaFlashAuthor account={noticia?.account} author={noticia?.author} />

                    {/* Compartir y última actualización */}
                    <Box sx={{ mb: 2 }}>
                        <ShareArticleAdminComponent
                            title={`${h1}\n\n👉 Actualización de estado\n\n ℹ️ Recomendación fantasy.\n\n✍️ Por ${getTwitterAuthor(
                                noticia.author
                            )}`}
                            ruta={`${router.asPath}`}
                            icon={`⚡️`}
                            hashtags={['noticiasFlash', 'fantasyFlash']}
                        />
                        <UltimaActualizacionComponent date={noticia?.generalStatus?.updated} />
                    </Box>

                    {/* Card del estado del jugador */}
                    <NoticiaFlashPlayerCard noticia={noticia} />

                    {/* Información del Jugador Plantilla */}
                    <NoticiaFlashJugadorInfo jugadorPlantilla={jugadorPlantillaMapeado} />

                    {/* Redes sociales */}
                    <Box sx={{ mt: 2 }}>
                        <AnaliticaSocialNetworks />
                    </Box>
                </Grid>

                {/* Columna de ayuda - 3/12 en desktop */}
                <Grid size={{ xs: 12, md: 3 }}>
                    <NoticiaFlashAyudaModal />
                </Grid>
            </Grid>
        </Box>
    );
};

export default NoticiasFlashSingleComponent;
